import React from 'react'

const DashboardIcon = ({ 
  size = 24, 
  color = "currentColor",
  strokeWidth = 1.5 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M1.93359 11.3755L11.9998 2.75L22.0659 11.3755" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <path 
        d="M4.09277 10.1602V21.2511H19.9103V10.1602" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <path 
        d="M11.9998 12.7051L11.9998 16.1135" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
    </svg>
  )
}

export default DashboardIcon;